import React, { useState, useEffect } from "react";
import { Row, Col, Card, Form, Button, Spinner, Table, Badge } from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import axiosInstance from "../../../services/AxiosInstance";
import swal from "sweetalert";
import moment from "moment";

const Indiamart = () => {
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [fetchingLeads, setFetchingLeads] = useState(false);
    const [instances, setInstances] = useState([]);
    const [templates, setTemplates] = useState([]);
    const [leads, setLeads] = useState([]);
    
    const [formData, setFormData] = useState({
        crmKey: "",
        instanceId: "",
        templateId: "",
        isActive: true
    });

    useEffect(() => {
        loadData();
        loadLeads();
    }, []);

    const loadData = async () => {
        setLoading(true);
        try {
            // Load Instances
            const instanceRes = await axiosInstance.post("message/instances");
            if (instanceRes.data && instanceRes.data.status) {
                setInstances(instanceRes.data.inatances || []);
            }

            // Load Templates
            const templateRes = await axiosInstance.post("message/templates");
            if (templateRes.data && templateRes.data.status) {
                setTemplates(templateRes.data.templates || []);
            }

            // Load Current Integration
            const integrationRes = await axiosInstance.get("indiamart");
            if (integrationRes.data && integrationRes.data.status && integrationRes.data.integration) {
                const integration = integrationRes.data.integration;
                setFormData({
                    crmKey: integration.crmKey || "",
                    instanceId: integration.instanceId?._id || integration.instanceId || "",
                    templateId: integration.templateId?._id || integration.templateId || "",
                    isActive: integration.isActive ?? true
                });
            }
        } catch (error) {
            console.error("Error loading IndiaMart data:", error);
            // swal("Error", "Failed to load integration settings", "error");
        }
        setLoading(false);
    };

    const loadLeads = async () => {
        setFetchingLeads(true);
        try {
            const { data } = await axiosInstance.get("indiamart/leads");
            if (data.status) {
                setLeads(data.leads || []);
            }
        } catch (error) {
            console.error("Error loading leads:", error);
        }
        setFetchingLeads(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!formData.crmKey || !formData.instanceId || !formData.templateId) {
            swal("Validation Error", "Please fill all required fields", "warning");
            return;
        }

        setSaving(true);
        try {
            const { data } = await axiosInstance.post("indiamart", formData);
            if (data.status) {
                swal("Success", data.message, "success");
            } else {
                swal("Error", data.message, "error");
            }
        } catch (error) {
            swal("Error", "Failed to save settings", "error");
        }
        setSaving(false);
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
                <Spinner animation="border" variant="primary" />
            </div>
        );
    }

    return (
        <>
            <PageTitle motherMenu="Dashboard" activeMenu="IndiaMart CRM" />
            <Row>
                <Col xl={12}>
                    <Card>
                        <Card.Header>
                            <Card.Title>IndiaMart CRM Integration</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    <Col md={12} className="mb-4">
                                        <p className="text-muted">
                                            Integrate your IndiaMart Lead Manager with our platform to automatically send WhatsApp messages to new leads.
                                        </p>
                                    </Col>
                                    
                                    <Col md={6} className="mb-3">
                                        <Form.Group>
                                            <Form.Label className="font-w600 text-black">IndiaMart CRM Key (glusr_crm_key)</Form.Label>
                                            <Form.Control 
                                                type="text" 
                                                name="crmKey"
                                                value={formData.crmKey}
                                                onChange={handleChange}
                                                placeholder="Enter your CRM Key"
                                                required
                                            />
                                            <Form.Text className="text-muted">
                                                You can find this key in your IndiaMart Seller Panel -&gt; Settings -&gt; API settings.
                                            </Form.Text>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6} className="mb-3">
                                        <Form.Group>
                                            <Form.Label className="font-w600 text-black">WhatsApp Instance</Form.Label>
                                            <Form.Control 
                                                as="select" 
                                                name="instanceId"
                                                value={formData.instanceId}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="">Select Instance</option>
                                                {instances.map(inst => (
                                                    <option key={inst.id} value={inst.id}>
                                                        {inst.name} ({inst.waNumber || 'Not Connected'})
                                                    </option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6} className="mb-3">
                                        <Form.Group>
                                            <Form.Label className="font-w600 text-black">Message Template</Form.Label>
                                            <Form.Control 
                                                as="select" 
                                                name="templateId"
                                                value={formData.templateId}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="">Select Template</option>
                                                {templates.map(tmpl => (
                                                    <option key={tmpl.id} value={tmpl.id}>
                                                        {tmpl.name}
                                                    </option>
                                                ))}
                                            </Form.Control>
                                            <Form.Text className="text-muted">
                                                Available variables: {'{{name}}'}, {'{{product}}'}, {'{{email}}'}, {'{{company}}'}
                                            </Form.Text>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6} className="mb-3 d-flex align-items-center">
                                        <Form.Group className="mt-4">
                                            <Form.Check 
                                                type="switch"
                                                id="isActive-switch"
                                                label="Enable Integration"
                                                name="isActive"
                                                checked={formData.isActive}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={12} className="mt-3">
                                        <Button type="submit" variant="primary" disabled={saving}>
                                            {saving ? <><Spinner size="sm" animation="border" className="mr-2" /> Saving...</> : 'Save Integration Settings'}
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xl={12}>
                    <Card>
                        <Card.Header>
                            <Card.Title>Recent IndiaMart Leads</Card.Title>
                            <Button variant="outline-primary" size="sm" onClick={loadLeads} disabled={fetchingLeads}>
                                {fetchingLeads ? <Spinner size="sm" animation="border" /> : <i className="fa fa-refresh"></i>}
                            </Button>
                        </Card.Header>
                        <Card.Body>
                            {fetchingLeads && leads.length === 0 ? (
                                <div className="text-center p-4">
                                    <Spinner animation="border" variant="primary" />
                                </div>
                            ) : leads.length === 0 ? (
                                <div className="text-center p-4">
                                    <p className="text-muted">No leads synced yet. Automation runs every 10 minutes.</p>
                                </div>
                            ) : (
                                <Table responsive className="w-100">
                                    <thead>
                                        <tr>
                                            <th>SN</th>
                                            <th>Date</th>
                                            <th>Sender Name</th>
                                            <th>Mobile</th>
                                            <th>Product</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {leads.map((lead, index) => (
                                            <tr key={lead._id}>
                                                <td>{index + 1}</td>
                                                <td>{moment(lead.createdAt).format("DD/MM/YYYY hh:mm A")}</td>
                                                <td>{lead.name}</td>
                                                <td>{lead.phone}</td>
                                                <td>{lead.product}</td>
                                                <td>
                                                    <Badge variant="success light">Processed</Badge>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            )}
                        </Card.Body>
                    </Card>
                </Col>

                <Col xl={12}>
                    <Card>
                        <Card.Header>
                            <Card.Title>How it works</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <ol>
                                <li>Get your **glusr_crm_key** from IndiaMart Seller Panel.</li>
                                <li>Ensure you have at least one **WhatsApp Instance** connected and authenticated.</li>
                                <li>Create a **Template** with your desired message. You can use variables like {"{{name}}"} to personalize the message.</li>
                                <li>Once saved and enabled, our system will check for new leads every 10 minutes and send the messages automatically.</li>
                            </ol>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default Indiamart;
